export default __webpack_public_path__ + "static/media/logodesign.5185b2d9.gif";